import { render, staticRenderFns } from "./SupportedPlatforms.vue?vue&type=template&id=28c6d57f&scoped=true&"
import script from "./SupportedPlatforms.vue?vue&type=script&lang=js&"
export * from "./SupportedPlatforms.vue?vue&type=script&lang=js&"
import style0 from "./SupportedPlatforms.vue?vue&type=style&index=0&id=28c6d57f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6d57f",
  null
  
)

export default component.exports